import { makeStyles } from '@mui/styles'
const useStylesSeeMoreOrganization = makeStyles(() => ({
  fieldsTypography: {
    mt: 2,
    mb: 1,
    fontSize: 15,
    color: '#1F2024',
    fontWeight: 'bold',
    marginTop: '5%',
    marginBottom: '2%'
  },
  mainTypography: {
    marginTop: 2,
    marginBottom: 1,
    fontWeight: 'bold',
    color: '#32332E',
    fontSize: 18
  },
  backgroundBox: {
    width: '100%'
  },
  mainBox: {
    width: '100%',
    marginTop: '0.8rem'
  },
  seeMoreTypography: {
    fontWeight: 'bold',
    color: '#3B3B40',
    fontSize: 18,
    paddingLeft: '3%'
  },
  closeButton: {
    position: 'absolute',
    width: '95%',
    marginLeft: '3%',
    bottom: 20,
    display: 'flex'
  },
  closeButtonStyle: {
    width: 90,
    height: 35,
    backgroundColor: '#1C846F',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    borderRadius: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  closeButtonTypography: {
    color: '#FFFFFF',
    cursor: 'pointer',
    fontSize: 16
  },
  container: {
    width: '100%',
    paddingTop: '1rem',
    paddingLeft: '4%'
  },
  gridContainerSeparator: {
    marginLeft: '1%',
    width: '100%',
    marginTop: '4%'
  },
  key: {
    fontSize: 14,
    color: '#6B6B6B',
    fontWeight: 'bold',
    letterSpacing: '0.02rem',
    fontFamily: 'Roboto'
  },
  value: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#3B3B40',
    fontFamily: 'Roboto'
  }
}))

export default useStylesSeeMoreOrganization
